import { FormEvent } from 'react';
import { LoginRequest } from '../../../api/types';
import {
  FieldError,
  FormErrorSummary,
  getFieldValidationProps,
} from '../../../components/FormValidation';
import { VitegoAppIcon } from '../../../components/VitegoAppIcon';
import { FormErrors } from '../../../utils/formValidation';
import { ThemeToggleButton } from '../components/ThemeToggleButton';
import { AdminTheme } from '../theme';

interface AdminLoginPageProps {
  form: LoginRequest;
  fieldErrors: FormErrors;
  isSubmitting: boolean;
  message: string | null;
  onChange: (form: LoginRequest) => void;
  onSubmit: (event: FormEvent<HTMLFormElement>) => void;
  onThemeToggle: () => void;
  theme: AdminTheme;
}

export function AdminLoginPage({
  form,
  fieldErrors,
  isSubmitting,
  message,
  onChange,
  onSubmit,
  onThemeToggle,
  theme,
}: AdminLoginPageProps) {
  return (
    <main className="admin-auth-page" data-palette="vitego" data-theme={theme}>
      <section className="admin-auth-card" aria-label="Вход администратора">
        <ThemeToggleButton onClick={onThemeToggle} theme={theme} />
        <div className="admin-auth-brand">
          <span className="admin-auth-brand__mark"><VitegoAppIcon /></span>
          <span>
            <strong>Vitego</strong>
            <small>Администрирование</small>
          </span>
        </div>
        <p className="admin-eyebrow">Управление</p>
        <h1>Админ-панель</h1>
        <p className="admin-caption">Вход для администраторов.</p>
        <form className="admin-form" noValidate onSubmit={onSubmit}>
          <FormErrorSummary errors={fieldErrors} message={message} />
          <label className="admin-field">
            <span>Электронная почта</span>
            <input
              {...getFieldValidationProps(fieldErrors, 'user_email')}
              aria-label="Электронная почта"
              autoComplete="email"
              onChange={(event) => onChange({ ...form, user_email: event.target.value })}
              placeholder="admin@example.com"
              type="email"
              value={form.user_email}
            />
            <FieldError errors={fieldErrors} fieldName="user_email" />
          </label>
          <label className="admin-field">
            <span>Пароль</span>
            <input
              {...getFieldValidationProps(fieldErrors, 'password')}
              aria-label="Пароль"
              autoComplete="current-password"
              onChange={(event) => onChange({ ...form, password: event.target.value })}
              placeholder="Введите пароль"
              type="password"
              value={form.password}
            />
            <FieldError errors={fieldErrors} fieldName="password" />
          </label>
          <button className="admin-submit" disabled={isSubmitting} type="submit">
            {isSubmitting ? 'Проверяем доступ...' : 'Войти'}
          </button>
        </form>
      </section>
    </main>
  );
}
